import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'auto',
  },
  loader: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  moreLoader: {
    width: '100%',
    height: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  skeletonBox: {
    height: 110,
    padding: [0, theme.spacing(2)],
    [theme.breakpoints.up('mobile')]: {
      padding: [0, theme.spacing(4)],
    },
    borderBottom: [1, 'solid', theme.palette.colors.divider],
    display: 'flex',
    alignItems: 'center',
  },
  skeletonText: {
    width: '100%',
    height: 50,
    borderRadius: 8,
    marginLeft: theme.spacing(3),
  },
  emptyLabel: {
    display: 'flex',
    padding: [theme.spacing(1)],
    marginTop: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.colors.warning,
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/components/LoanOfficersList/useStyles.js